module.exports = __webpack_public_path__ + "9bca736d94bbb0fde70feed6ba53d7c7.png";